import { render } from "./Dialog.vue?vue&type=template&id=84c2e820&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=84c2e820&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-84c2e820"

export default script